module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lrHBO"))).then(() => parcelRequire('1iHdE'));